/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FormRequestModel } from '../../models/form-request-model';

export interface AnonymousFormsPost$Params {
  isTemplate?: boolean | null;
      body?: FormRequestModel
}

export function anonymousFormsPost(http: HttpClient, rootUrl: string, params?: AnonymousFormsPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<string>>> {
  const rb = new RequestBuilder(rootUrl, anonymousFormsPost.PATH, 'post');
  if (params) {
    rb.query('isTemplate', params.isTemplate, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<string>>;
    })
  );
}

anonymousFormsPost.PATH = '/Anonymous/Forms';
